// extracted by mini-css-extract-plugin
module.exports = {"trustedRetailerBanner":"Sf-z","trustedRetailerTooltipWrapper":"Tf-z"};